// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3FvAc","overflowing":"ReadFullNote_overflowing__C0bIP"};